import React from 'react';
import PropTypes from 'prop-types';
import { BackButton } from '../../components/Button';
import { ViewTitle } from '../../components/ViewTitle';

// eslint-disable-next-line arrow-body-style
const EditWorks = ({ title, subtitle }) => {
  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  return (
    <div>
      {renderTitle()}
      <div className="flex flex-row justify-start pb-4">
        <div>
          <BackButton />
        </div>
        <div className="text-lg font-semibold ml-6">แก้ไขงาน</div>
      </div>
    </div>
  );
};

EditWorks.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

EditWorks.defaultProps = {
  title: '',
  subtitle: '',
};
export default EditWorks;
